














import { Prop, Component, Vue } from 'vue-property-decorator'
import { Contact } from '@/api/model/contact'
import { escapeHtml, sanitizeHtml } from '@/helpers/html'

@Component
export default class FormAppraisalEnrichCompleted extends Vue {
    @Prop({ required: true }) readonly contact!: Contact

    prevPage(): void {
        this.$router.push({
            name: 'form_appraisal_enrich_edit',
        })
    }

    get description(): string {
        // The translation has markup (<br>); the name is text
        return sanitizeHtml(this.$t('form-appraisal-enrich.completed.description', {
            firstname: escapeHtml(this.contact.displayName),
        }).toString())
    }
}
